import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: "#3CBAB3",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 11,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function createData(elasticidad, fecha, precio, cantidad) {
  return { elasticidad, fecha, precio, cantidad };
}


const useStyles = makeStyles({
  table: {
    minWidth: '100%',
  },
});

export default function CustomizedTables(props) {
  
  let dataTable = props.data;
  const rows = [
    createData('Histórico', dataTable.Historico.Fecha, dataTable.Historico.Precio, dataTable.Historico.Cantidad),
    createData('Actual', dataTable.Actual.Fecha, dataTable.Actual.Precio, dataTable.Actual.Cantidad),
    // createData(dataTable.Elasticidad.toFixed(4)),
    // createDa
  ];

  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{padding: 11}}></StyledTableCell>
            <StyledTableCell style={{padding: 11}} align="right">Fecha</StyledTableCell>
            <StyledTableCell style={{padding: 11}} align="right">Precio</StyledTableCell>
            <StyledTableCell style={{padding: 11}} align="right">Cantidad</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <StyledTableRow key={row.name}>
              <StyledTableCell style={{padding: 11}} component="th" scope="row">
                {row.elasticidad}
              </StyledTableCell>
              <StyledTableCell style={{padding: 11}} align="right">{row.fecha}</StyledTableCell>
              <StyledTableCell style={{padding: 11}} align="right">{row.precio}</StyledTableCell>
              <StyledTableCell style={{padding: 11}} align="right">{row.cantidad}</StyledTableCell>
            </StyledTableRow>
          ))}
          <StyledTableRow key={'elasticidad neta'}>
              <StyledTableCell style={{padding: 11, fontWeight: 'bold'}} component="th" scope="row">
                Elasticidad: {dataTable.Elasticidad.toFixed(3)}
              </StyledTableCell>
            </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}